export default {
  // Navigation
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_article: 'SEO Article',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_lang: 'EN',
  nav_home: 'Home',
  nav_guide: 'Shopping Guide',
  search_placeholder: 'Search category...',
  related_content: 'Related Content',
  back_to_home: 'Back to main page',
  visit_main_site: 'Visit main website',
  more_articles: 'More articles',

  // Hero
  hero_title: 'CSSBuy Spreadsheet – Products, Guides & Resources for China Shopping',
  hero_subtitle: 'Explore an independent and organized resource about CSSBuy Spreadsheet with product categories, buying guides, QC information, shipping details, and safety tips to help you research better before purchasing.',
  hero_cta_primary: 'CSSBuy Spreadsheet',
  hero_cta_secondary: 'Buy It Now',
  hero_trust_1: 'Independent Resource',
  hero_trust_2: 'Practical Guides',
  hero_trust_3: 'Organized Information',
  hero_trust_4: 'Regularly Updated',

  // What Is Section
  what_is_title: 'What is CSSBuy Spreadsheet?',
  what_is_text: 'CSSBuy Spreadsheet is a practical way to organize and discover products, links, and information related to the shopping research process. You can explore categories and organized resources to make your research easier.',
  what_is_cta: 'Explore CSSBuy Spreadsheet',

  // Categories
  categories_title: 'Product Categories',
  categories_subtitle: 'Explore our organized categories to find products quickly',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',

  // Benefits
  benefits_title: 'Why Use a CSSBuy Spreadsheet?',
  benefits_subtitle: 'Discover the advantages of organizing your product research',
  benefit_1_title: 'Find Products Faster',
  benefit_1_text: 'Browse organized categories and find exactly what you are looking for without wasting time.',
  benefit_2_title: 'Organize Links and Categories',
  benefit_2_text: 'Keep all your links and favorite products organized in one place.',
  benefit_3_title: 'Compare Information Before Buying',
  benefit_3_text: 'Access detailed guides and compare options to make informed decisions.',
  benefit_4_title: 'Consult QC Guides and Tips',
  benefit_4_text: 'Learn how to check product quality before completing your purchase.',
  benefit_5_title: 'Understand Shipping Options Better',
  benefit_5_text: 'Learn about different shipping methods and choose the best one for you.',

  // How It Works
  how_title: 'How It Works',
  how_subtitle: 'Follow these simple steps to make the most of CSSBuy Spreadsheet',
  step_1: 'Find a Product',
  step_1_text: 'Browse categories and find items that interest you.',
  step_2: 'Consult the CSSBuy Spreadsheet',
  step_2_text: 'Access our organized resources for more information.',
  step_3: 'Check the Information',
  step_3_text: 'Review details, guides, and tips before proceeding.',
  step_4: 'Check QC When Available',
  step_4_text: 'Analyze quality photos and reviews when possible.',
  step_5: 'Research Shipping and Costs',
  step_5_text: 'Understand shipping options and calculate costs.',
  step_6: 'Verify Before Purchase',
  step_6_text: 'Confirm all information before finalizing.',
  step_7: 'Continue to Main Website',
  step_7_text: 'Visit kaspreadsheet.com to complete your purchase.',

  // Safety
  safety_title: 'Safety First',
  safety_text: 'Never share your password or payment data with unknown third parties. Always confirm the domain before entering information. Prices, products, and shipping information may change, so check current data before purchasing.',
  safety_cta: 'View Safety Guide',

  // Articles
  articles_title: 'Articles & Guides',
  articles_subtitle: 'Original content to help you navigate CSSBuy Spreadsheet',
  read_more: 'Read more',

  // Article card
  article_1_title: 'What is CSSBuy Spreadsheet? A Complete Guide for Beginners',
  article_1_desc: 'Discover how CSSBuy Spreadsheet works, how to use the organized categories, and how to make the most of this resource for your product research.',
  article_1_date: 'August 28, 2026',

  // Footer
  footer_disclaimer: 'This website is an independent informational resource and is not affiliated with CSSBuy.',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_contact: 'Contact',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. All rights reserved.',

  // Dropdown
  dropdown_title: 'Select Category',
  dropdown_all: 'All Categories',

  // Disclaimer
  disclaimer: 'This website is an independent informational resource and is not affiliated with, operated by, or endorsed by CSSBuy.',

  // CTA buttons
  cta_main_site: 'Visit Main Website',
  cta_explore: 'Explore Now',
  cta_view_products: 'View Products',
  cta_title: 'Ready to explore the CSSBuy Spreadsheet?',
  cta_subtitle: 'Search products, consult our guides, and find organized resources to make your research easier.',

  // 404
  not_found_title: 'Page Not Found',
  not_found_text: 'The page you are looking for does not exist.',
  not_found_back: 'Back to Home',
};